import { WhatsNew } from "@/common/model/WhatsNew";
import ItemCard from "../shared/ItemCard";
import StatusBadge from "../shared/StatusBadge";
import ActionButtons from "../shared/ActionButtons";
import { formatDateForDisplay } from "@/utils/dateUtils";

type WhatsNewItemProps = {
  whatsNew: WhatsNew;
  onEdit: (whatsNew: WhatsNew) => void;
  onDelete: (whatsNew: WhatsNew) => void;
};

const WhatsNewItem: React.FC<WhatsNewItemProps> = ({
  whatsNew,
  onEdit,
  onDelete,
}) => {
  const content = (
    <div className="grid lg:grid-cols-2 gap-4">
      <div>
        <p className="text-white90 font-semibold">{whatsNew.title}</p>
        {whatsNew.url && (
          <p className="text-blue-400 text-sm mt-2 break-all">
            <a href={whatsNew.url} target="_blank" rel="noopener noreferrer">
              {whatsNew.url}
            </a>
          </p>
        )}
      </div>
      <div className="lg:text-right">
        <p className="text-white90">
          Start: {formatDateForDisplay(whatsNew.startDate)}
        </p>
        <p className="text-white90">
          End: {formatDateForDisplay(whatsNew.endDate)}
        </p>
        <div className="mt-2 flex justify-end">
          <StatusBadge status={whatsNew.status || ""} />
        </div>
      </div>
    </div>
  );

  const footer = (
    <ActionButtons
      onEdit={() => onEdit(whatsNew)}
      onDelete={() => onDelete(whatsNew)}
    />
  );

  return <ItemCard content={content} footer={footer} />;
};

export default WhatsNewItem;
